import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  MarketingFlow,
  UpdateMarketingFlowStatusPayload
} from "../../marketing.types";
import { requestUpdateMarketingFlowStatus } from "./updateMarketingFlowStatus.request";

const useUpdateMarketingFlowStatus = (
  options?: MutationOptions<
    MarketingFlow,
    ApiServiceError<ApiError>,
    UpdateMarketingFlowStatusPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateMarketingFlowStatus,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateMarketingFlowStatus;
